import type { CustomCondition } from '~/api/conditions/types';

import type { DialogHandles } from '../CustomConditionsTable.hooks';

import { mobileCellStyle } from './customConditionCell.css';
import { CustomConditionNameCell } from './CustomConditionNameCell';
import { CustomConditionOptionsCell } from './CustomConditionOptionsCell';

type Props = {
  customCondition: CustomCondition;
  dialogHandles: DialogHandles;
};

export const CustomConditionMobileCell = ({ customCondition, dialogHandles }: Props) => {
  return (
    <div className={mobileCellStyle}>
      <CustomConditionNameCell name={customCondition.name} />

      <CustomConditionOptionsCell customCondition={customCondition} dialogHandles={dialogHandles} />
    </div>
  );
};
